import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { MatSliderChange } from '@angular/material/slider';
import { Global } from '../classes/Global';
import { BaseComponent } from '../classes/BaseComponent';

@Component({
  selector: 'app-movie-ratings-sliders',
  templateUrl: './movie-ratings-sliders.component.html',
  styleUrls: ['./movie-ratings-sliders.component.scss']
})
export class MovieRatingsSlidersComponent extends BaseComponent implements OnInit {

  @Input() movieRatingsFilters : MovieRatingsFilters = new MovieRatingsFilters();
  @Output() onApply = new EventEmitter();

  currentValues: MovieRatingsFilters;

  constructor() {
    super();
  }

  ngOnInit() {
    this.init();
  }

  init() {
    this.currentValues = new MovieRatingsFilters(
      this.movieRatingsFilters.imdb,
      this.movieRatingsFilters.rotten,
      this.movieRatingsFilters.letterboxd,
      this.movieRatingsFilters.metacritic
    );
  }

  getCurrentStore(): string {
    return Global.getStore();
  }

  apply() {
    this.onApply.emit(
      this.currentValues
    );
  }

  imdbChange(change: MatSliderChange) {
    this.currentValues.setImdb(change.value);
  }

  rottenChange(change: MatSliderChange) {
    this.currentValues.setRotten(change.value);
  }

  letterboxdChange(change: MatSliderChange) {
    this.currentValues.setLetterboxd(change.value);
  }

  metacriticChange(change: MatSliderChange) {
    this.currentValues.setMeta(change.value);
  }

  getValueForDisplay(value): string {
    if(!value || value == 0) {
      return this.getString('all');
    }
    return value;
  }
}

export class MovieRatingsFilters {
  imdb: number = 0;
  rotten: number = 0;
  letterboxd: number = 0;
  metacritic: number = 0;
  constructor(imdb?: number, rotten?: number, letterboxd?: number, metacritic?: number) {
    this.setImdb(imdb);
    this.setRotten(rotten);
    this.setLetterboxd(letterboxd);
    this.setMeta(metacritic);
  }
  setImdb(value) {
    this.imdb = value > 0 ? (value <= 10 ? value : 10) : 0;
  }
  setRotten(value) {
    this.rotten = value > 0 ? (value <= 100 ? value : 100) : 0;
  }
  setLetterboxd(value) {
    this.letterboxd = value > 0 ? (value <= 5 ? value : 5) : 0;
  }
  setMeta(value) {
    this.metacritic = value > 0 ? (value <= 100 ? value : 100) : 0;
  }
  toString(): string {
    return "" + this.imdb + this.rotten + this.letterboxd + this.metacritic;
  }
}
